import { render } from "./TaxRates.vue?vue&type=template&id=852ce782"
import script from "./TaxRates.vue?vue&type=script&lang=js"
export * from "./TaxRates.vue?vue&type=script&lang=js"
script.render = render

export default script